<template>
  <div class="w-100" v-if="!tournamentStarted && registrationStatus">
    <div
      v-if="!isAuthenticated"
      class="rounded w-100 btn-participate-card-container"
      :style="{ backgroundColor: bgColor }"
      data-toggle="modal"
      data-target="#loginModal"
      @click="participateAction()"
    >
      <div class="p-4">
        <img :src="imageSrc" height="64px" />
      </div>
      <div
        class="btn-participate-card px-5 text-uppercase py-2 font-weight-bold text-center w-100 d-flex justify-content-center align-items-center"
      >
        <h5 class="mr-4 mb-0 btn-title">{{ label }}</h5>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="36"
          viewBox="0 0 19 36"
          class="p-1"
        >
          <path
            d="M18,19h0L0,0H6.261L18,12.392,29.739,0H36L18,19Z"
            transform="translate(0 36) rotate(-90)"
            fill="#fff"
          />
        </svg>
      </div>
    </div>
    <div
      v-else
      class="rounded w-100 btn-participate-card-container"
      :style="{ backgroundColor: bgColor }"
      data-toggle="modal"
      data-target="#lgame-participation-pop-up"
      @click="handleClick()"
    >
      <div class="p-4">
        <img :src="imageSrc" height="64px" />
      </div>
      <div>
        <div
          class="btn-participate-card px-5 text-uppercase py-2"
          v-if="registrationStatus && !tournamentStarted"
        >
          <div v-if="isParticipant">
            <h5 class="mr-4 mb-0 btn-title">Annuler ma participation</h5>
          </div>
          <div
            v-else
            class="font-weight-bold text-center w-100 d-flex justify-content-center align-items-center"
          >
            <h5 class="mr-4 mb-0 btn-title">{{ label }}</h5>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="36"
              viewBox="0 0 19 36"
              class="p-1"
            >
              <path
                d="M18,19h0L0,0H6.261L18,12.392,29.739,0H36L18,19Z"
                transform="translate(0 36) rotate(-90)"
                fill="#fff"
              />
            </svg>
          </div>
        </div>
        <div
          class="btn-participate-card px-5 text-uppercase py-2 font-weight-bold text-center w-100 d-flex justify-content-center align-items-center"
          v-else
        >
          <h5 class="mr-4 mb-0 btn-title">Inscriptions fermées</h5>
        </div>
      </div>
    </div>
    <!--<div class="participate-card-container">
      <div class="w-100" v-if="!isAuthenticated">
        <div class="d-flex justify-content-start w-100">
          <div
            class="text-center d-flex flex-column justify-content-center align-items-center"
            style="
              background-color: #f7f3ff;
              width: 64px;
              border-left: 4px red solid;
            "
          >
            <img src="" height="42px" />
          </div>
          <button
            class="participate-btn px-4"
            data-toggle="modal"
            data-target="#loginModal"
            @click="participateAction()"
          >
            S'inscrire
          </button>
        </div>
      </div>
      <div class="w-100" v-else>
        <div class="d-flex justify-content-start w-100">
          <div
            class="text-center d-flex flex-column justify-content-center align-items-center"
            style="
              background-color: #f7f3ff;
              width: 64px;
              border-left: 4px red solid;
            "
          >
            <img src="" height="42px" />
          </div>
          <button
            class="participate-btn px-4"
            data-toggle="modal"
            data-target="#lgame-participation-pop-up"
            @click="participateAction()"
            v-if="!isParticipant"
          >
            S'inscrire
            <span style="font-size: 12pt !important">{{
              game == "lol" ? "(LOL)" : "(EA FC24)"
            }}</span>
          </button>
          <button
            class="participate-btn px-4"
            data-toggle="modal"
            data-target="#lgame-participation-pop-up"
            @click="cancelParticipateAction(gameId)"
            v-else
          >
            Se desinscrire
          </button>
        </div>
        <h6
          class="font-weight-bold text-center"
          style="color: #e30923"
          v-if="isParticipant"
        >
          ( Vous êtes inscrit )
        </h6>
      </div>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import "moment";
import moment from "moment";
export default {
  name: "ParticipateCardGameValo",
  props: {
    game: {
      type: String,
    },
    gameId: {
      type: Number,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: "var(--blue-variant)",
    },
    label: {
      type: String,
      default: "Participer",
    },
  },
  data() {
    return {
      participantsSize: 0,
      startDate: moment().add(7, "days").valueOf(),
      today: moment().valueOf(),
      countDown: {
        days: null,
        hours: null,
        minutes: null,
        seconds: null,
      },
      diffTime: null,
      interval: 1000,
      duration: null,
      TYPE_PLAYER: 1,
      TYPE_TEAM: 2,
    };
  },
  computed: {
    isLoaded: {
      get() {
        return !!this.$store.state.currentTournamentValo.tournamentItem;
      },
      set(val) {
        return val;
      },
    },
    startDate_comp: {
      get() {
        if (this.isLoaded) {
          const date =
            this.$store.state.currentTournamentValo.tournamentItem.start_date;
          const time =
            this.$store.state.currentTournamentValo.tournamentItem.start_time;
          return moment(date + " " + time, "DD-MM-YYYY HH:mm").valueOf();
        }
        return null;
      },
    },
    isAuthenticated: {
      get() {
        return this.$store.state.currentUser.isAuthenticated;
      },
    },
    registrationStatus: {
      // true:  open, false: closed
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentTournamentValo.tournamentItem.settings
            .registration_status;
        }
      },
    },
    registrationEnds: {
      get() {
        if (this.isLoaded) {
          moment.locale("fr");
          const dateTime =
            this.$store.state.currentTournamentValo.tournamentItem.start_date +
            " " +
            this.$store.state.currentTournamentValo.tournamentItem.start_time;
          return moment(dateTime, "DD-MM-YYYY HH:mm").format(
            "ddd Do, MMM  [à] hA"
          );
        }
      },
    },
    isPastTournament: {
      get() {
        if (this.isLoaded) {
          const dateTime =
            this.$store.state.currentTournamentValo.tournamentItem.end_date +
            " " +
            this.$store.state.currentTournamentValo.tournamentItem.end_time;
          console.log(moment(dateTime, "DD-MM-YYYY HH:mm"));
          return moment().isAfter(moment(dateTime, "DD-MM-YYYY HH:mm"));
        }
      },
    },
    checkInStarted: {
      get() {
        if (this.isLoaded) {
          const startDateTime =
            this.$store.state.currentTournamentValo.tournamentItem.start_date +
            " " +
            this.$store.state.currentTournamentValo.tournamentItem.start_time;

          const checkInStartsIn =
            this.$store.state.currentTournamentValo.tournamentItem
              .check_in_starts;
          const checkinStartTime = moment(startDateTime, "DD-MM-YYYY HH:mm")
            .subtract(checkInStartsIn, "minutes")
            .toDate();
          return (
            moment().isBefore(moment(startDateTime, "DD-MM-YYYY HH:mm")) &&
            moment().isAfter(moment(checkinStartTime))
          );
        }
      },
    },
    tournamentStarted: {
      get() {
        if (this.isLoaded) {
          const startDateTime =
            this.$store.state.currentTournamentValo.tournamentItem.start_date +
            " " +
            this.$store.state.currentTournamentValo.tournamentItem.start_time;

          return moment().isSameOrAfter(
            moment(startDateTime, "DD-MM-YYYY HH:mm")
          );
        }
      },
    },
    participantType: {
      get() {
        if (this.isLoaded) {
          const size =
            this.$store.state.currentTournamentValo.tournamentItem.settings
              .play_mode.size;
          return size > 1 && size !== 0 ? this.TYPE_TEAM : this.TYPE_PLAYER;
        }
      },
    },
    tournamentSize: {
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentTournamentValo.tournamentItem.size;
        }
      },
    },
    participantCount: {
      get() {
        if (this.isLoaded) {
          return this.participantType === this.TYPE_PLAYER
            ? this.$store.state.currentTournamentValo.tournamentItem
                .participants_players.length
            : this.$store.state.currentTournamentValo.tournamentItem
                .participants_teams.length;
        }
        return 0;
      },
    },
    isParticipant: {
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentTournamentValo
            .playerTeamIsParticipant;
        }
      },
    },
    isParticipantCheckedIn: {
      get() {
        if (this.isLoaded) {
          if (this.participantType === this.TYPE_PLAYER)
            return this.$store.state.currentTournamentValo.playerIsCheckedIn;
          else
            return this.$store.state.currentTournamentValo
              .playerTeamIsCheckedIn;
        }
      },
    },
    hasCustomFields: {
      get() {
        if (this.isLoaded) {
          const customFields =
            this.$store.state.currentTournamentValo.tournamentItem.settings
              .custom_fields;
          return customFields !== null && customFields.length > 0;
        }
      },
    },
    isLoadingAction: {
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentTournamentValo.isLoadingAction;
        }
      },
    },
    teamParticipatedId: {
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentTournamentValo.teamParticipatedId;
        }
      },
    },
    isUserAuth: {
      get() {
        if (this.isLoaded) {
          return this.$store.state.currentUser.isAuthenticated;
        }
      },
    },
    storeModule: {
      get() {
        return;
        ("currentTournamentValo");
      },
    },
  },
  watch: {
    isUserAuth(newVal, oldVal) {
      if (oldVal === false && newVal === true && !this.isParticipant) {
        this.$store.dispatch("currentTournamentValo/checkParticipation");
      }
    },
  },
  methods: {
    handleClick() {
      if (this.isParticipant) {
        this.cancelParticipateAction();
      } else {
        this.participateAction();
      }
    },
    participateAction() {
      // participate current auth user

      if (this.isAuthenticated) {
        this.$store.dispatch(this.storeModule + "/triggerLoading", true);
        if (this.participantType === this.TYPE_TEAM) {
          this.$store.dispatch("currentTournamentValo/getCurrentPlayerTeams");
          this.$emit("init-pop-up", {
            type: "teams",
            title: "Choisir une équipe",
            message:
              "Choisir une équipe parmis vous equipes pour participer a cette tournoi:",
            withOptions: false,
            popUpDispatch: "currentTournamentValo/setParticipantTeam",
            game: "Valorant",
          });
        }
        if (this.participantType === this.TYPE_PLAYER) {
          if (this.hasCustomFields) {
            this.$emit("init-pop-up", {
              type: "custom",
              withOptions: true,
              title: "Formulaire d'inscription",
              message:
                "Merci de remplire les champs suivants pour participer au tournoi",
              options: {
                mainAction: "Participer",
                secondAction: "Annuler",
              },
              popUpDispatch: "currentTournamentValo/setParticipant",
            });
          } else {
            this.$store
              .dispatch("currentTournamentValo/setParticipant")
              .then(() => {
                this.$store.dispatch(
                  "currentTournamentValo/triggerLoading",
                  false
                );
              });
          }
        }
      } else {
        this.$root.$emit("show-login", "check_participation");
      }
    },
    cancelParticipateAction() {
      this.$store.dispatch(this.storeModule + "/triggerLoading", true);
      if (this.participantType === this.TYPE_PLAYER) {
        console.log("cancelling player participation");
        this.$emit("init-pop-up", {
          type: "warning",
          withOptions: true,
          title: "Attention !",
          message: "Etes-vous sur de vouloir annuler votre participation ?",
          popUpDispatch: "currentTournamentValo/cancelParticipation",
        });
        /*this.$store.dispatch('currentTournament/cancelParticipation')
                        .then(() => {
                            this.isLoadingAction = false;
                        });*/
      }
      if (this.participantType === this.TYPE_TEAM) {
        this.$emit("init-pop-up", {
          type: "warning",
          withOptions: true,
          title: "Attention !",
          message: "Etes-vous sur de vouloir annuler votre participation ?",
          popUpDispatch: "currentTournamentValo/cancelTeamParticipation",
        });
        console.log("cancelling team participation");
        /*this.$store.dispatch('currentTournament/cancelTeamParticipation')
                        .then(() => {
                            this.isLoadingAction = false;
                        });*/
      }
    },
    checkPlayerIn() {
      this.$store.dispatch(this.storeModule + "/checkPlayerIn");
    },
    checkParticipantIn() {
      this.$store.dispatch(this.storeModule + "/triggerLoading", true);
      if (this.participantType === this.TYPE_TEAM) {
        this.$store
          .dispatch(this.storeModule + "/checkTeamIn", {
            teamId: this.teamParticipatedId,
            checkinValue: true,
          })
          .then(() => {
            this.$store.dispatch(this.storeModule + "/triggerLoading", false);
          });
      }
      if (this.participantType === this.TYPE_PLAYER) {
        this.$store
          .dispatch(this.storeModule + "/checkPlayerIn", {
            checkinValue: true,
          })
          .then(() => {
            this.$store.dispatch(this.storeModule + "/triggerLoading", false);
          });
      }
    },
    cancelCheckIn() {
      //only team case done
      this.$store.dispatch(this.storeModule + "/triggerLoading", true);
      if (this.participantType === this.TYPE_PLAYER) {
        this.$emit("init-pop-up", {
          type: "warning",
          withOptions: true,
          title: "Attention !",
          message: "Etes-vous sur de vouloir annuler votre checkin ?",
          popUpDispatch: this.storeModule + "/checkPlayerIn",
          dispatchData: {
            checkinValue: false,
          },
        });
      }
      if (this.participantType === this.TYPE_TEAM) {
        this.$emit("init-pop-up", {
          type: "warning",
          withOptions: true,
          title: "Attention !",
          message: "Etes-vous sur de vouloir annuler votre checkin ?",
          popUpDispatch: this.storeModule + "/checkTeamIn",
          dispatchData: {
            teamId: this.teamParticipatedId,
            checkinValue: false,
          },
        });
      }
    },
    viewBracket() {
      this.$emit("view-bracket");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.btn-participate-card-container:hover {
  cursor: pointer;
  transform: scale(1.01);
  transition: transform 0.3s ease-in-out;
}
.btn-participate-card {
  background: #fff;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 35%,
    rgba(255, 255, 255, 0.35) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-family: "race_sportregular" !important;
}
.btn-title {
  font-family: "race_sportregular" !important;
}
.participate-card-container {
}
.card-title {
  font-family: "Gemunu Libre ExtraBold";
  font-size: 26pt;
}
.number-item {
  font-family: "Long-shot";
  font-size: 56pt;
  text-transform: uppercase;
}
.unit-item {
  font-family: "Long-shot";
  font-size: 28pt;
  text-transform: uppercase;
}
.countdown-title {
  font-family: "Gemunu Libre Bold";
}
.participants-status {
  font-family: "Gemunu Libre Bold";
}
.participate-btn {
  border: unset;
  background: #e30923;
  outline: none;
  color: white;
  background-size: 100% 100%;
  height: 48px;
  font-family: "Gemunu Libre Bold";
  font-size: 20pt;
  text-transform: uppercase;
  font-weight: 700;
}
.participate-btn:hover {
  transform: translateX(1px);
  transition: scale 0.1s linear;
}
</style>
